
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FileState {
  file: File | null;
}

const initialState: FileState = {
  file: null,
};

const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    uploadFile: (state, action: PayloadAction<File>) => {
      state.file = action.payload;
    },
    removeFile: (state) => {
      state.file = null;
    },
  },
});

export const { uploadFile, removeFile } = fileSlice.actions;
export default fileSlice.reducer;

